import { CarViewBody } from '@/components/CarView/types';

import crossoverBlueUrl from './crossover/blue.png';
import crossoverGreyUrl from './crossover/grey.png';
import crossoverOrangeUrl from './crossover/orange.png';
import sedanBlueUrl from './sedan/blue.png';
import sedanGreyUrl from './sedan/grey.png';
import sedanOrangeUrl from './sedan/orange.png';
import minibusBlueUrl from './minibus/blue.png';
import minibusGreyUrl from './minibus/grey.png';
import minibusOrangeUrl from './minibus/orange.png';
import vanBlueUrl from './van/blue.png';
import vanGreyUrl from './van/grey.png';
import vanOrangeUrl from './van/orange.png';
import stationWagonBlueUrl from './stationWagon/blue.png';
import stationWagonGreyUrl from './stationWagon/grey.png';
import stationWagonOrangeUrl from './stationWagon/orange.png';
import coupeBlueUrl from './coupe/blue.png';
import coupeGreyUrl from './coupe/grey.png';
import coupeOrangeUrl from './coupe/orange.png';
import cabrioletBlueUrl from './cabriolet/blue.png';
import cabrioletGreyUrl from './cabriolet/grey.png';
import cabrioletOrangeUrl from './cabriolet/orange.png';
import hatchbackBlueUrl from './hatchback/blue.png';
import hatchbackGreyUrl from './hatchback/grey.png';
import hatchbackOrangeUrl from './hatchback/orange.png';
import liftbackBlueUrl from './liftback/blue.png';
import liftbackGreyUrl from './liftback/grey.png';
import liftbackOrangeUrl from './liftback/orange.png';
import chassisBlueUrl from './chassis/blue.png';
import chassisGreyUrl from './chassis/grey.png';
import chassisOrangeUrl from './chassis/orange.png';
import minivanBlueUrl from './minivan/blue.png';
import minivanGreyUrl from './minivan/grey.png';
import minivanOrangeUrl from './minivan/orange.png';
import pickupBlueUrl from './pickup/blue.png';
import pickupGreyUrl from './pickup/grey.png';
import pickupOrangeUrl from './pickup/orange.png';
import suvBlueUrl from './suv/blue.png';
import suvGreyUrl from './suv/grey.png';
import suvOrangeUrl from './suv/orange.png';

export const getBody = (bodyType: CarViewBody) => {
  switch (bodyType) {
    case 'hatchback':
      return {
        grey: hatchbackGreyUrl,
        blue: hatchbackBlueUrl,
        orange: hatchbackOrangeUrl,
      };

    case 'sedan':
      return {
        grey: sedanGreyUrl,
        blue: sedanBlueUrl,
        orange: sedanOrangeUrl,
      };

    case 'station_wagon':
      return {
        grey: stationWagonGreyUrl,
        blue: stationWagonBlueUrl,
        orange: stationWagonOrangeUrl,
      };

    case 'coupe':
      return {
        grey: coupeGreyUrl,
        blue: coupeBlueUrl,
        orange: coupeOrangeUrl,
      };

    case 'cabriolet':
      return {
        grey: cabrioletGreyUrl,
        blue: cabrioletBlueUrl,
        orange: cabrioletOrangeUrl,
      };

    case 'minivan':
      return {
        grey: minivanGreyUrl,
        blue: minivanBlueUrl,
        orange: minivanOrangeUrl,
      };

    case 'van':
      return {
        grey: vanGreyUrl,
        blue: vanBlueUrl,
        orange: vanOrangeUrl,
      };

    case 'pickup':
      return {
        grey: pickupGreyUrl,
        blue: pickupBlueUrl,
        orange: pickupOrangeUrl,
      };

    case 'suv':
      return {
        grey: suvGreyUrl,
        blue: suvBlueUrl,
        orange: suvOrangeUrl,
      };

    case 'crossover':
      return {
        grey: crossoverGreyUrl,
        blue: crossoverBlueUrl,
        orange: crossoverOrangeUrl,
      };

    case 'minibus':
      return {
        grey: minibusGreyUrl,
        blue: minibusBlueUrl,
        orange: minibusOrangeUrl,
      };

    case 'lift_back':
      return {
        grey: liftbackGreyUrl,
        blue: liftbackBlueUrl,
        orange: liftbackOrangeUrl,
      };

    case 'chassis':
      return {
        grey: chassisGreyUrl,
        blue: chassisBlueUrl,
        orange: chassisOrangeUrl,
      };

    case 'bus':
      return {
        grey: minibusGreyUrl,
        blue: minibusBlueUrl,
        orange: minibusOrangeUrl,
      };

    case 'shooting_brake':
      return {
        grey: crossoverGreyUrl,
        blue: crossoverBlueUrl,
        orange: crossoverOrangeUrl,
      };

    default:
      return {
        grey: crossoverGreyUrl,
        blue: crossoverBlueUrl,
        orange: crossoverOrangeUrl,
      };
  }
};
